"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filter = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
exports.Filter = function (props) { return (React.createElement(Icon_styled_1.StyledSvg, tslib_1.__assign({}, props, { viewBox: "0 0 15 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("line", { x1: "1", y1: "11", x2: "14", y2: "11", stroke: props.stroke, strokeWidth: "2", strokeLinecap: "round" }),
    React.createElement("circle", { cx: "6", cy: "11", r: "2", fill: props.fill, stroke: props.stroke, strokeWidth: "2" }),
    React.createElement("line", { x1: "1", y1: "3", x2: "14", y2: "3", stroke: props.stroke, strokeWidth: "2", strokeLinecap: "round" }),
    React.createElement("circle", { cx: "10", cy: "3", r: "2", fill: props.fill, stroke: props.stroke, strokeWidth: "2" }))); };
//# sourceMappingURL=filter.js.map